import TermsAndConditions from '../../container/PolicyPages/TermsAndConditions';

function TermsConditions() {
  return <TermsAndConditions />;
}

export default TermsConditions;
